import api from "./api";
import StorageService from "./StorageService";

const FuelPurchaseReportService = {

  getReport: async (filters) => {
    const comp = StorageService.activeCompany();
    const loginData = StorageService.loginData();

    const params = {
      companyId: comp.companyId,
      employeeId: loginData?.employeeId || null,
      roleId: loginData?.roleId || null,
      pageNumber: filters.pageNumber || 1,
      noofRows: filters.noofRows || 20,
      projectCategoryId: filters.projectCategoryId || null,
      project: filters.project || null,
      vendorName: filters.vendorName || null,
      fromDate: filters.fromDate || null,
      toDate: filters.toDate || null,
      invoiceNo: filters.invoiceNo || null
    };

    const res = await api.get("/fuelPurchaseReport/getReport", {
      params
    });

    return res.data;
  },

  exportExcel: async (filters) => {
    const comp = StorageService.activeCompany();
    const loginData = StorageService.loginData();

    const params = {
      companyId: comp.companyId,
      employeeId: loginData?.employeeId || null,
      roleId: loginData?.roleId || null,
      projectCategoryId: filters.projectCategoryId || null,
      project: filters.project || null,
      vendorName: filters.vendorName || null,
      fromDate: filters.fromDate || null,
      toDate: filters.toDate || null,
      invoiceNo: filters.invoiceNo || null
    };

    const res = await api.get("/fuelPurchaseReport/exportExcel", {
      params
    });

    return res.data?.data || [];
  },

  getSuppliers: async (filters) => {
    const comp = StorageService.activeCompany();
    const loginData = StorageService.loginData();

    const params = {
      companyId: comp.companyId,
      employeeId: loginData?.employeeId || null,
      roleId: loginData?.roleId || null,
      projectCategoryId: filters.projectCategoryId || null,
      project: filters.project || null
    };

    const res = await api.get("/fuelPurchaseReport/getSuppliers", {
      params
    });

    return res.data?.data || [];
  }

};

export default FuelPurchaseReportService;
